import { render, staticRenderFns } from "./PresaleSubmit.vue?vue&type=template&id=4519e924&scoped=true"
import script from "./PresaleSubmit.vue?vue&type=script&lang=js"
export * from "./PresaleSubmit.vue?vue&type=script&lang=js"
import style0 from "./PresaleSubmit.vue?vue&type=style&index=0&id=4519e924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519e924",
  null
  
)

export default component.exports